export { default } from './FavoritesContainer';
